
import VueAxios from "vue-axios";
import axios from "axios";
//Vue.use(VueAxios, axios);
//Vue.use(Vuex)
//const this.$store.state.baseapi = "http://127.0.0.1:8000/api/";
export default {
    data() {
      return {
       
      }
    },
  
    created() {
     
    },
  
    methods: {
     
     GET_POA_LINEAS_ACCION: async function(data) {




      
      var result =  await axios
        ({
          method: 'GET',
          url: this.$store.state.baseapi+"poas/"+data.poas_id+"/poa_lineas_acciones/" ,
          responseType: 'json',
          headers: {
        
            "Content-Type": "application/json",
            'X-Authorization': 'Bearer ' +this.$store.state.user.token

          },
            
          }
          
        )
        .then(
          response => {
         
            //context.commit('SET_USER_DEALS', { deals: response.data.data })
            return response.data;
          },
          err => {
            
            return null;
          }
        );
        return result;





    },








    CREAR_POA_LINEAS_ACCION: async function(data) {



      
      var result =  await axios
        ({
          method: 'POST',
          url: this.$store.state.baseapi+"poa_lineas_acciones/" ,
          responseType: 'json',
          headers: {
        
            "Content-Type": "application/json",
            'X-Authorization': 'Bearer ' +this.$store.state.user.token

          },
          data:{
          //QUITAR COMILLAS SOLO EN DATA 
         
          
          poas_id:data.poas_id,
          pmd_id:data.pmd_id,
          nombre:data.nombre,
          idprogramatica:data.idprogramatica,
          poblacion_objetivo:data.poblacion_objetivo,
          tipo_poblacion:data.tipo_poblacion,
          meta:data.meta,
          idfinalidades:data.idfinalidades,
          idfunciones:data.idfunciones,
          idsubfunciones:data.idsubfunciones,
          indicador_administradores_id:data.indicador_administradores_id,
        
                
          }
            
          }
          
        )
        .then(
          response => {
         
            //context.commit('SET_USER_DEALS', { deals: response.data.data })
            return response.data;
          },
          err => {
            
            return null;
          }
        );
        return result;





    },





    EDITAR_POA_LINEAS_ACCION: async function(data) {




      
      var result =  await axios
        ({
          method: 'PUT',
          url: this.$store.state.baseapi+"poa_lineas_acciones/"+data.id ,
          responseType: 'json',
          headers: {
        
            "Content-Type": "application/json",
            'X-Authorization': 'Bearer ' +this.$store.state.user.token

          },
          data:{
          
          'nombre':data.nombre,
          pmd_id:data.pmd_id,
          idprogramatica:data.idprogramatica,
          'poblacion_objetivo':data.poblacion_objetivo,
          'tipo_poblacion':data.tipo_poblacion,
          'meta':data.meta,
          idfinalidades:data.idfinalidades,
          idfunciones:data.idfunciones,
          idsubfunciones:data.idsubfunciones,
          
          'indicador_administradores_id':data.indicador_administradores_id,
            
          }
            
          }
          
        )
        .then(
          response => {
         
            //context.commit('SET_USER_DEALS', { deals: response.data.data })
            return response.data;
          },
          err => {
            
            return null;
          }
        );
        return result;





    },

    ELIMINAR_POA_LINEAS_ACCION: async function(data) {




      
      var result =  await axios
        ({
          method: 'delete',
          url: this.$store.state.baseapi+"poa_lineas_acciones/"+data.id ,
          responseType: 'json',
          headers: {
        
            "Content-Type": "application/json",
            'X-Authorization': 'Bearer ' +this.$store.state.user.token

          }
            
          }
          
        )
        .then(
          response => {
         
            //context.commit('SET_USER_DEALS', { deals: response.data.data })
            return response.data;
          },
          err => {
            
            return null;
          }
        );
        return result;





    },
    },
  }